var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.875,
    height: 16.787,
    viewBox: "0 0 23.875 16.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-youtube",
    "data-name": "Icon awesome-youtube",
    d: "M24.426,7.127A3,3,0,0,0,22.315,5c-1.862-.5-9.328-.5-9.328-.5S5.522,4.5,3.66,5A3,3,0,0,0,1.549,7.127a31.47,31.47,0,0,0-.5,5.784,31.47,31.47,0,0,0,.5,5.784A2.955,2.955,0,0,0,3.66,20.785c1.862.5,9.328.5,9.328.5s7.466,0,9.328-.5a2.955,2.955,0,0,0,2.111-2.091,31.47,31.47,0,0,0,.5-5.784,31.47,31.47,0,0,0-.5-5.784ZM10.546,16.46v-7.1l6.24,3.55-6.24,3.55Z",
    transform: "translate(-1.05 -4.5)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.925f57e36a160919258670b8d9faa83d.svg";
export { ForwardRef as ReactComponent };